import classNames from "classnames";

import "./ReadyBadge.css";

interface ReadyBadgeProps {
  enabled: boolean;
}
function ReadyBadge({ enabled }: ReadyBadgeProps) {
  const topLevelClassNames = classNames("readyBadge", "shine", {
    enabled: enabled,
    disabled: !enabled,
  });

  return (
    <div>
      <div className={topLevelClassNames}>ready</div>
    </div>
  );
}

export default ReadyBadge;
